module.exports = __webpack_public_path__ + "img/33.80dcf8b3.jpg";